module.exports = __webpack_public_path__ + "static/damascus-3b1f87a3fe8ef134761a59d9a84462e3.svg";